// "#ECECEC"
export default {
  backgroundColor: "#ffffff",
  fontColor: "#1A1A1A"
};
